export default __webpack_public_path__ + "static/media/ticket.8b017e98.svg";